module.exports = __webpack_public_path__ + "static/media/laxmiraj-banner2.04a439ed.png";